import { GetApplicationResponse } from '@iwoca/lapi-client/edge';

import { normaliseStepData } from '../../components/helpers/stateNormalisation';
import {
  APPLICANT_STEP_ID,
  BUSINESS_STEP_ID,
} from '../../components/helpers/steps';
import {
  businessStepValidator,
  passesStep0Validation,
  personalStepValidator,
} from '../../components/helpers/stepValidators/stepValidatorsUK';
import { TGetStateResponse, TSignupStepsUK } from '../../types';

type TGetLatestStepUK = {
  newState: TGetStateResponse['data'];
  newApplication: GetApplicationResponse['data'];
  partnerCustomer: boolean;
  activeStep?: TSignupStepsUK;
  companyQuestionsEnabled?: boolean;
};

export const getLatestStepUK = ({
  newState,
  newApplication,
  activeStep,
  partnerCustomer,
  companyQuestionsEnabled = false,
}: TGetLatestStepUK): TSignupStepsUK => {
  const normalisedState = normaliseStepData({ data: newState });

  if (newApplication?.is_closed) {
    return 'decision';
  }

  const passesStep0 = passesStep0Validation(
    normalisedState['new'],
    newApplication,
  );

  if (!passesStep0) {
    return 'new';
  }

  if (activeStep) {
    return activeStep;
  }

  const passesBusinessStep = businessStepValidator(
    normalisedState[BUSINESS_STEP_ID],
  );

  if (!passesBusinessStep) {
    return 'business';
  }

  const passesApplicantStep = personalStepValidator(
    normalisedState[APPLICANT_STEP_ID],
  );

  if (companyQuestionsEnabled && !passesApplicantStep) {
    return 'company-questions';
  }

  if (!passesApplicantStep) {
    return 'applicant';
  }

  return partnerCustomer ? 'offers' : 'documents';
};
